module.exports = __webpack_public_path__ + "img/V25.3d9d9522.png";